import * as React from 'react'

import { Box, TogglerCheckbox } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import EmployeeSelector from 'modules/core/components/EmployeeSelector'
import DayPicker from 'modules/core/components/Inputs/DayPicker'
import Select from 'modules/core/components/Inputs/Select'
import i18n from 'modules/core/lib/i18n'

import employees from 'modules/employees/store/collections/employees'
import type Employee from 'modules/employees/store/models/Employee'
import AddEmployeesNoticeBox from 'modules/shift_management/components/ShiftManagement/AddEmployeesNoticeBox'
import EmployeesSelector from 'modules/shift_management/components/ShiftManagement/EmployeesSelector'
import { useEnabledFeatures } from 'modules/shift_management/hooks/useEnabledFeatures'
import type ImportEmployeesToSMForm from 'modules/shift_management/lib/forms/ImportEmployeesToSMForm'
import { maxDate, minDate } from 'modules/shift_management/lib/getMinMaxDates'
import numberOfRestDaysOptions from 'modules/time_planning/lib/numberOfRestDaysOptions'

import type { IdsType, IdsTypes } from './useImportEmployeesSM'

interface Props {
  form: ImportEmployeesToSMForm
  selectableEmployeeIds: number[]
  onSelectEmployee: (id: IdsTypes) => void
  selectedEmployeeIds: IdsType
}

const FormContent = ({
  form,
  selectableEmployeeIds,
  onSelectEmployee,
  selectedEmployeeIds,
}: Props) => {
  const [{ hasFeatureFlag }] = useEnabledFeatures()
  const hasRestDays = hasFeatureFlag('shift_management_rest_day')
  const [open, toggle] = React.useState<boolean>(false)
  const onChangeNumberOfRestDaysCheckbox = (value: boolean) => {
    if (!value) {
      form.get('number_of_rest_days_in_cents').set(null)
    }

    toggle(value)
  }

  const hasNewEmployeesSelector = hasFeatureFlag('dev_shift_management_new_employees_selector')

  let selectableEmployees: Employee[] = []
  if (!hasNewEmployeesSelector) {
    selectableEmployees = employees.filter((employee) =>
      selectableEmployeeIds.includes(employee.id)
    )
  }

  return (
    <Box gap="s16">
      {hasNewEmployeesSelector ? (
        <EmployeesSelector
          alwaysOpen
          field={form.get('employee_id')}
          selectableEmployeeIds={selectableEmployeeIds}
          onSelectEmployee={onSelectEmployee}
          selectedEmployeeIds={selectedEmployeeIds}
          width="s400"
        />
      ) : (
        <EmployeeSelector
          employees={selectableEmployees}
          onSelectEmployee={onSelectEmployee}
          onSelectMultiple={onSelectEmployee}
          selectedEmployeeIds={selectedEmployeeIds}
          virtualized
        />
      )}
      <AddEmployeesNoticeBox />
      <DayPicker
        field={form.get('effective_at')}
        label={i18n.t('shift_management.import_employees.effective_date')}
        minDate={minDate}
        maxDate={maxDate}
      />
      {hasRestDays && (
        <>
          <TogglerCheckbox
            label={i18n.t(
              'time_planning.planning_versions.forms.apply_number_of_rest_days_checkbox'
            )}
            value={open}
            onChange={onChangeNumberOfRestDaysCheckbox}
          />
          {open && (
            <Select
              field={form.get('number_of_rest_days_in_cents')}
              label={i18n.t('time_planning.planning_versions.forms.number_of_rest_days')}
              options={numberOfRestDaysOptions()}
            />
          )}
        </>
      )}
    </Box>
  )
}

export default observer(FormContent)
